import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loader from '../../component/loader/Loader'
import DataTable from '../../component/data_table/DataTable'
import { res, configurationHistoryTodo } from '../../redux/slices/tooling-configuration/ConfigurationHistory'

export default function ConfigurationHistory() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const history = useSelector(state => state?.configurationHistory?.data?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(configurationHistoryTodo({ navigate })).then(() => list_res())
    }, [])

   const list_res = (res) => {
        if (res?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }
    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 70,
        },
        {
            headerName: 'Min Edge Trim',
            field: 'min_edge',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'Max Edge Trim',
            field: 'max_edge',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'Min Good Piece Length',
            field: 'min_good_piece_length',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'Min Final Length',
            field: 'min_final_length',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'Max Welds per Coil',
            field: 'max_welds',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'Defect',
            field: 'defect',
            cellRenderer: params => {
                try {
                    const defectArray = JSON.parse(params.value); // convert string → array
                    return defectArray.map(d => d.label).join(', '); // show labels
                } catch (e) {
                    return ''; // fallback if not JSON
                }

            },
            autoHeight: true,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
            width: '350px'
        },

        // {
        //     headerName: 'STATUS',
        //     field: 'status',
        //     cellRenderer: params =>
        //         params?.data?.status === 'Active'
        //             ? <span className='badge text-bg-success'>Active</span>
        //             : <span className='badge text-bg-danger'>Inactive</span>,
        //     filter: 'agTextColumnFilter',
        //     suppressHeaderMenuButton: true,
        //     sortable: true,
        //     floatingFilter: false,
        // },
        // {
        //     headerName: 'ACTION',
        //     cellRenderer: params => (
        //         <div className='d-flex'>
        //             <span
        //                 onClick={() => editUser(params?.data)}
        //             >
        //                 <FilePenLine className='text-success' size={20} />
        //             </span>
        //             <span className='ms-2'
        //                 onClick={() => deleteUser(params?.data?._id)}
        //             >
        //                 <Trash2 className='text-danger' size={20} />
        //             </span>
        //         </div>
        //     ),
        //     autoHeight: true,
        // }
    ];
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="layout_head mb-3">
                            <h5>Tooling Configuration History</h5>
                        </div>
                        {loading ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={history}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}
